<template lang="pug">
  div
    div(class="mb-3 headline") Breakdown of unresolved maintenance jobs
    div(v-if="loading")
      div(style="display: flex; justify-content: center;")
        v-progress-circular(size="50" indeterminate)
    div(v-else)
      pie-chart(:data="categories"
                :library="style"
                :dataset="dataset")

</template>

<script>
export default {
  name: "unresolved-breakdown",
  data () {
    return {
      categories: {},
      dataset: {
        backgroundColor: [],
        borderColor: "#303030",
        borderWidth: []
      },
      error: false,
      loading: false,
      style: {
        legend: {
          labels: { fontColor: "white" },
          position: "right"
        },
        cutoutPercentage: 40
      }
    };
  },
  created () {
    const colors = [
      "#EDE7F6",
      "#D1C4E9",
      "#B39DDB",
      "#9575CD",
      "#7E57C2",
      "#673AB7",
      "#5E35B1",
      "#512DA8",
      "#4527A0",
      "#311B92"
    ];
    this.loading = true;
    this.$http.
      get("/api/reports/performance?period=open").
      then(({ data: perfs }) => {
        for (let i = 0; i < perfs.length; i += 1) {
          if (perfs[i]["Issues count"]) {
            this.$set(
              this.categories,
              perfs[i].Category,
              perfs[i]["Issues count"]
            );
            this.dataset.borderWidth.push(3);
            this.dataset.backgroundColor.push(colors[i]);
          }
        }
      }).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/UnresolvedBreakdown.vue